import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Wizard from '../../components/Wizard';

function WizardPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Campaign Wizard
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Create a new campaign with offers and traffic sources in just a few steps.
        </Typography>
        <Box>
          <Wizard />
        </Box>
      </Box>
    </Container>
  );
}

export default WizardPage;
